import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// reacthook form
import {
    UseFormGetValues,
    UseFormRegisterReturn,
    UseFormSetValue,
    Controller,
} from "react-hook-form";
// mui
import { Autocomplete, TextField } from "@mui/material";
// icons
import { AiOutlineLoading3Quarters } from "react-icons/ai";
// alerts
import { errorAlert } from "../../utils/alerts/alerts";
// types
import { ReduxUserReducerState } from "../../types/global";

type Props = {
    getValues: UseFormGetValues<any>;
    errorMessage?: string | undefined;
    setValue: UseFormSetValue<any>;
    control: any;
    name?: string;
};

const SelectArea = ({
    getValues,
    errorMessage,
    setValue,
    control,
    name = "area",
}: Props) => {
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const [areas, setAreas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    // // get alll cities
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(`/areas?&sorts=-name&page=1&paginate=120`)
            .then((res: AxiosResponse) => {
                const newAreasForm = res.data.data.map((area: any) => {
                    const v = { id: area.id, name: area.name };
                    return v;
                });
                setAreas(newAreasForm);
                setLoading(false);
            })
            .catch((error: AxiosError) => errorAlert(error));
    }, []);
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <Autocomplete
                    sx={{ width: "100%" }}
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    isOptionEqualToValue={(option: any, value: any) =>
                        option?.id === value?.id
                    }
                    getOptionLabel={(option: any) => option?.name}
                    options={areas}
                    loading={loading}
                    {...field}
                    onChange={(e, item: any) => {
                        setValue(name, item);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="المنطقة"
                            helperText={errorMessage}
                            error={errorMessage ? true : false}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {loading ? (
                                            <AiOutlineLoading3Quarters />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}
                />
            )}
        />
    );
};

export default SelectArea;
